import React from 'react';
import { Sparkles } from 'lucide-react';

export function AIIslandInput({
  value,
  onChange,
  onSubmit,
  onFocus,
  placeholder,
  inputRef,
  shortcutLabel,
  variant = 'drawer',
}) {
  const handleKeyDown = (event) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault();
      if (typeof onSubmit === 'function') {
        onSubmit();
      }
    }
  };

  if (variant === 'dock') {
    return (
      <div className="ai-island-input ai-island-input--dock">
        <Sparkles size={16} className="ai-island-input__icon" />
        <input
          ref={inputRef}
          type="text"
          className="ai-island-input__field"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onFocus={onFocus}
          onKeyDown={handleKeyDown}
        />
        {shortcutLabel && <span className="ai-island-input__shortcut">{shortcutLabel}</span>}
      </div>
    );
  }

  return (
    <div className="ai-island-input">
      <Sparkles size={16} className="ai-island-input__icon" />
      <input
        ref={inputRef}
        type="text"
        className="ai-island-input__field"
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        onFocus={onFocus}
        onKeyDown={handleKeyDown}
      />
      {shortcutLabel && <span className="ai-island-input__shortcut">{shortcutLabel}</span>}
    </div>
  );
}
